<div class="modal-header">
	<h4 class="modal-title fw-bold">
		@if (modeView === ModeView.VIEW) {
			<span jhiTranslate="ontology-manager.tab.properties.modal.detail.header"></span>
		} @else if (modeView === ModeView.EDIT) {
			<span jhiTranslate="ontology-manager.tab.properties.modal.edit.header"></span>
		} @else if (modeView === ModeView.CREATE) {
			<span jhiTranslate="ontology-manager.tab.properties.modal.create.header"></span>
		}
	</h4>
	<button type="button" class="btn-close" data-bs-dismiss="modal"
			(click)="clear()">
	</button>
</div>
<div class="modal-body">
	<div class="row" *ngIf="showNoEditableFieldAlert()">
		<div class="col">
			<div class="alert alert-warning" role="alert">
				<i class="fa fa-warning pe-2"></i>
				<span jhiTranslate="ontology-manager.validation.property.noneditableFields"></span>
			</div>
		</div>
	</div>
	<form name="form" #f="ngForm">
		<div class="mb-3 row">
			<label for="propertyName" class="col-sm-3 col-form-label fw-bold" jhiTranslate="ontology-manager.tab.properties.modal.property.name">Name</label>
			<div class="col-sm-9">
				<jhi-input
					name="propertyName"
					[property]="'name'"
					[model]="propertyDetails"
					[modeView]="modeView"
					[disabled]="isLoading"
					[required]="true"
					[maxLength]="NAME_TEXT_LIMIT"
					[pattern]="SPECIAL_CHARACTERS"
					[(ngModel)]="propertyDetails.name"
					#propertyName="ngModel">
				</jhi-input>
				@if ((f.submitted || propertyName.touched) && propertyName.errors?.required) {
					<div class="text-danger pt-2">{{ 'ontology-manager.validation.name.required' | translate }}</div>

				} @else if ((f.submitted || propertyName.dirty) && propertyName.errors?.maxlength) {
					<div class="text-danger pt-2">{{ 'ontology-manager.validation.field.maxlength' | translate : { maxLength: NAME_TEXT_LIMIT } }}</div>

				} @else if ((f.submitted || propertyName.dirty) && propertyName.errors?.pattern) {
					<div class="text-danger pt-2">{{ 'ontology-manager.validation.name.pattern' | translate : { pattern: SPECIAL_CHARACTERS } }}</div>
				}
			</div>
		</div>
		<div class="mb-3 row">
			<label for="description" class="col-sm-3 col-form-label fw-bold" jhiTranslate="ontology-manager.tab.properties.modal.property.description">Description</label>
			<div class="col-sm-9">
				<jhi-textarea
					name="description"
					[modeView]="modeView"
					[model]="propertyDetails"
					[property]="'description'"
					[disabled]="isLoading"
					[required]="false"
					[maxLength]="DESCRIPTION_TEXT_LIMIT"
					[pattern]="SPECIAL_CHARACTERS"
					[(ngModel)]="propertyDetails.description"
					#description="ngModel">
				</jhi-textarea>
				@if (f.submitted || description.dirty) {
					@if (description.errors?.maxlength) {
						<div class="text-danger pt-2">{{ 'ontology-manager.validation.field.maxlength' | translate : { maxLength: DESCRIPTION_TEXT_LIMIT } }}</div>
					} @else if (description.errors?.pattern) {
						<div class="text-danger pt-2">{{ 'ontology-manager.validation.description.pattern' | translate : { pattern: SPECIAL_CHARACTERS } }}</div>
					}
				}
			</div>
		</div>
		<div class="mb-3 row">
			<label for="classes" class="col-sm-3 control-label fw-bold" jhiTranslate="ontology-manager.tab.properties.modal.property.classes">Classes</label>
			<div class="col-sm-9">
				<jhi-multi-select
					name="classes"
					[modeView]="modeView"
					[model]="propertyDetails"
					[property]="'classes'"
					[options]="classes"
					[required]="true"
					[appendable]="true"
					[labelField]="'text'"
					[idField]="'id'"
					[placeholder]="'ontology-manager.property.classes.dropdown.placeholder' | translate"
					(ngModelChange)="onClassesChanged($event)"
					[(ngModel)]="selectedClasses"
					#classesCtrl="ngModel">
				</jhi-multi-select>
			</div>
		</div>
		<div class="mb-3 row">
			<label for="cropOntologyId" class="col-sm-3 control-label fw-bold" jhiTranslate="ontology-manager.tab.properties.modal.property.crop.ontology.id">Crop Ontology ID</label>
			<div class="col-sm-9">
				<jhi-input
					name="cropOntologyId"
					[property]="'name'"
					[model]="propertyDetails"
					[modeView]="modeView"
					[disabled]="isLoading"
					[required]="false"
					[maxLength]="NAME_TEXT_LIMIT"
					[pattern]="SPECIAL_CHARACTERS"
					[(ngModel)]="propertyDetails.cropOntologyId"
					#cropOntologyId="ngModel">
				</jhi-input>
				@if (f.submitted || cropOntologyId.dirty) {
					@if (cropOntologyId.errors?.maxlength) {
						<div class="text-danger pt-2">{{ 'ontology-manager.validation.field.maxlength' | translate : { maxLength: NAME_TEXT_LIMIT } }}</div>
					} @else if (cropOntologyId.errors?.pattern) {
						<div class="text-danger pt-2">{{ 'ontology-manager.validation.variable.crop.ontology.id.pattern' | translate }}</div>
					}
				}
			</div>
		</div>
	</form>
	<br>
	<jhi-metadata [modeView]="modeView" [metadata]="propertyDetails.metadata" [extendedUsage]="false"></jhi-metadata>
</div>
<div class="modal-footer">
	@if (modeView === ModeView.EDIT || modeView === ModeView.CREATE) {
		<button type="button" class="btn btn-secondary" (click)="discard()">
			<span class="fa fa-ban"></span>&nbsp;<span jhiTranslate="discard"></span>
		</button>
		<button (click)="save()" [disabled]="!isFormValid(f)" class="btn btn-primary">
			<span *ngIf="isLoading" class="throbber throbber-btn"></span>
			<span class="fa fa-save"></span>&nbsp;
			@if (modeView === ModeView.EDIT) {
				<span jhiTranslate="update"></span>
			} @else {
				<span jhiTranslate="create"></span>
			}
		</button>
	} @else {
		<button type="button" class="btn btn-secondary" (click)="clear()">
			<span jhiTranslate="back"></span>
		</button>
		@if (isDeletable()) {
			<button type="button" class="btn btn-info me-2" (click)="delete()">
				<span class="fa fa-trash"></span>&nbsp;<span jhiTranslate="delete"></span>
			</button>
		}
		<button type="button" class="btn btn-outline-info" (click)="edit()">
			<span class="fa fa-pencil"></span>&nbsp;<span jhiTranslate="edit"></span>
		</button>
	}
</div>
